if (!customElements.get("collapsible-tabs")) {
	customElements.define(
		"collapsible-tabs",
		class CollapsibleTabs extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.detailsElements = this.querySelectorAll(".accordion-details");
				this.colorScheme = this.dataset.colorScheme;

				this.detailsElements.length > 0 &&
					this.detailsElements.forEach((details) => {
						details.open ? this.handleOpen(details) : this.handleClose(details);
						details.addEventListener("toggle", this.onToggle.bind(this));
					});
			}

			onToggle(event) {
				const activeDetails = event.target;
				if (activeDetails.open) {
					this.handleOpen(activeDetails);
				} else {
					this.handleClose(activeDetails);
				}
			}

			handleOpen(details) {
				const parent = details.closest(".accordion-item");
				parent.classList.contains("accordion-card") && parent.classList.add(this.colorScheme);

				this.autoScrollToTab(details);
			}

			handleClose(details) {
				const parent = details.closest(".accordion-item");
				parent.classList.contains("accordion-card") && parent.classList.remove(this.colorScheme);
			}

			async autoScrollToTab(details) {
				const summary = details.querySelector("summary");
				if (summary === undefined) {
					return;
				}

				await new Promise((r) => setTimeout(r, 250)); // Wait till animation is finished

				const isInViewport = await this.isSummaryInViewport(summary);
				if (!isInViewport) {
					details.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			}

			async isSummaryInViewport(summary) {
				return new Promise((res) => {
					const observer = new IntersectionObserver(
						([entry], obs) => {
							res(entry.isIntersecting);
							obs.disconnect();
						},
						{
							threshold: 0.01,
						}
					);

					observer.observe(summary);
				});
			}
		}
	);
}

document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll("[data-toggle-id]").forEach(function (btn) {
		btn.addEventListener("click", function () {
			var id = btn.getAttribute("data-toggle-id");
			var target = document.getElementById(id);
			var isOpen = target.classList.toggle("open");
			btn.setAttribute("aria-expanded", isOpen);
			btn.classList.toggle("open", isOpen);
		});
	});
});
